import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { updateClaimType, deleteDocTypeAll } from '../reducers/formActions';

import iconCoppy from '../images/summary/ic_coppy_2.svg'


function ContactRefNo(props) {

  const [contactRefNo, setContactRefNo] = useState(  props.contact_info.ref_no  )
 
  function coppyTrackNoToClipboard(){
    navigator.clipboard.writeText(contactRefNo)
  }
  
  return (
    <div className='flex w-full items-center  flex-wrap'>
        <span className='w-fit text-lg  text-[14px] text-[#ADADAD] font-normal  '>เลขที่รายการ: <span data-testid='referenceNo-text' >{contactRefNo}</span> </span>

      <div className='flex-none flex'>
        <div className='flex'>
          <img data-testid='copy-referenceNo-button' onClick={ (e) => { coppyTrackNoToClipboard() }} src={iconCoppy} alt="icon-copy" className='ml-[8px]  filter contrast-0 cursor-pointer w-[16px] h-[16px]' />
        </div>
        
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  return state
}

export default connect(mapStateToProps)(ContactRefNo);